export default __webpack_public_path__ + "static/media/warning.1785776060741.svg";